module.exports = __webpack_public_path__ + "static/media/white-background.d504f994.jpg";